<!-- HandHalloween.vue -->
<template>
	<div class="hand-halloween" aria-hidden="true">
		<!-- внутрішній шар для окремої анімації “махання” -->
		<div class="hand-halloween__inner">
			<svg-sprite width="46" height="46" icon-id="hand-halloween" halloween />
		</div>
	</div>
</template>

<script>
export default { name: 'HandHalloween' };
</script>

<!-- БАЗОВІ стилі компонента (scoped): позиціювання, початковий стан -->
<style scoped lang="scss">
.hand-halloween {
	position: absolute;
	z-index: 20;
	/* стартова позиція біля кнопки */
	top: -7px;
	left: 10%;

	/* дивиться вгору — можна підкрутити при потребі */
	transform: rotate(-90deg);
	transform-origin: 50% 50%;

	opacity: 0;
	visibility: hidden;
	pointer-events: none;

	transition:
			transform 220ms ease,
			opacity 220ms ease,
			visibility 0s linear 220ms; /* ховаємо після згасання */

	will-change: transform, opacity;

	.hand-halloween__inner {
		/* точка обертання ближче до “зап’ястя” */
		transform-origin: 22% 82%;
	}
}

/* коли користувач просить менше анімації */
@media (prefers-reduced-motion: reduce) {
	.hand-halloween,
	.hand-halloween__inner {
		animation: none !important;
		transition: none !important;
	}
}
</style>

<!-- ГЛОБАЛЬНІ стилі-тригери: реакція на .btnWrapAuthorization .apply:hover -->
<style lang="scss">
/* важливо: цей блок НЕ scoped, щоб селектори досягали батьківської розмітки */

.btnWrapAuthorization { position: relative; }

/* по ховеру на зеленій кнопці показуємо руку і зсуваємо її
   на 54px вліво та 20px вгору від стартової точки */
.btnWrapAuthorization .apply:hover ~ .halloween-head .hand-halloween {
	opacity: 1;
	visibility: visible;
	transform: translate(-54px, -20px) rotate(-90deg);
	transition-delay: 0s; /* показуємо одразу */
}

/* махання рукою — вмикаємо тільки при ховері на .apply */
.btnWrapAuthorization .apply:hover ~ .halloween-head .hand-halloween .hand-halloween__inner {
	animation: hand-wave 0.85s ease-in-out infinite;
}

/* ключові кадри: легке розгойдування вліво/вправо + невеликий зсув */
@keyframes hand-wave {
	0%   { transform: rotate(-8deg) translateX(0); }
	25%  { transform: rotate(6deg)  translateX(3px); }
	50%  { transform: rotate(10deg) translateX(5px); }
	75%  { transform: rotate(-4deg) translateX(2px); }
	100% { transform: rotate(-8deg) translateX(0); }
}
</style>
